// @ts-nocheck
import buttonSizeVariants from "@insite/mobius/Button/buttonSizeVariants";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

/** buttonSizeVariants
 * ------------------------------------------------------------------------------------------
 * height: Height applied as "min-height" (px)
 * fontSize: Font size (px)
 * padding: CSS applied to the padding property "padding: [VALUE];"
 * icon: Icon size (px)
 * iconPadding: Spacing between the icon and the text (px)
 */

Object.assign(buttonSizeVariants, {
    small: {
        height: 34, // Store Custom Code
        fontSize: 12, // Store Custom Code
        padding: pxToRem(0, 24), // Store Custom Code
        icon: 24, // Store Custom Code
        iconPadding: 4, // Store Custom Code
    },
    medium: {
        height: 40,
        fontSize: 14, // Store Custom Code
        padding: pxToRem(0, 24), // Store Custom Code
        icon: 24, // Store Custom Code
        iconPadding: 4, // Store Custom Code
    },
    large: {
        height: 48, // Store Custom Code
        fontSize: 14, // Store Custom Code
        padding: pxToRem(0, 30), // Store Custom Code
        icon: 24,
        iconPadding: 12, // Store Custom Code
    },
    xlarge: {
        height: 48, // Store Custom Code
        fontSize: 14, // Store Custom Code
        padding: pxToRem(0, 30), // Store Custom Code
        icon: 24, // Store Custom Code
        iconPadding: 12, // Store Custom Code
    },
});
